import { Pipe, PipeTransform } from '@angular/core';

/**
 * Transforms a Map into an array of its keys.
 *
 * It is useful for iterating over keys of a Map in Angular templates.
 *
 * @example
 * ```html
 * <!-- Assume 'paymentMethods' is a Map<string, number> with various entries -->
 * <div *ngFor="let key of paymentMethods | keys">
 *   Key: {{ key }}, Value: {{ paymentMethods.get(key) }}
 * </div>
 * <!-- This will list all keys and their corresponding values from the 'paymentMethods' map -->
 * ```
 */
@Pipe({
  standalone: true,
  name: 'keys',
})
export class KeysPipe<K, V> implements PipeTransform {
  transform(value: Map<K, V>): K[] {
    return Array.from(value.keys());
  }
}
